import { PosState } from "./../../../stores/PosSlice";
import { Account } from "../features/account/models/Account";
import { BaseProduct } from "../models";
import { updateStateAfterMembershipCheckIn } from "./MembershipAllocationUtilsHelper";
import { handleFeeRemoval, updateFeeQuantity } from "./MembershipFeesUtils";

// Membership State Management Helper Functions
/* Function updates the allocatedMembership to a participant */
export const assignMembershipToParticipant = (
  state: PosState,
  participantId: number,
  membership: BaseProduct
) => {
  if (!state.selectedAccount) return;

  state.selectedAccount.waiverParticipants?.forEach((participant: Account) => {
    if (participant.id === participantId) {
      participant.allocatedMembership = membership;
      membership.assignedPeople?.push(participant);
    }
  });
};

/* Function removes the allocatedMembership from a participant */
export const unAssignMembershipFromParticipant = (
  state: PosState,
  participantId: number,
  removeFromCart?: boolean
) => {
  if (!state.selectedAccount) return;

  state.selectedAccount.waiverParticipants?.forEach((participant: Account) => {
    if (participant.id === participantId) {
      const membership = participant.allocatedMembership;
      if (membership) {
        const membershipInCart = state.itemsInCart?.find(
          (r) => r.productId === membership.productId
        );
        if (membershipInCart) {
          membershipInCart.assignedPeople = [
            ...(membershipInCart?.assignedPeople?.filter(
              (r) => r.id != participantId
            ) ?? []),
          ];
          if (removeFromCart) {
            if (membershipInCart.assignedPeople.length == 0) {
              state.itemsInCart = state.itemsInCart?.filter(
                (r) => r.productId != membershipInCart.productId
              );
              handleFeeRemoval(state, membershipInCart);
            } else {
              membershipInCart.quantity--;
              updateFeeQuantity(state, membershipInCart);
            }
          }
        }
      }
      participant.allocatedMembership = undefined;
    }
  });
};

/* Function removes the allocated membership from a participant */
export const unAssignAllMemberships = (state: PosState) => {
  if (!state.selectedAccount) return;

  state.selectedAccount.waiverParticipants?.forEach((participant: Account) => {
    const membership = participant.allocatedMembership;
    if (membership) {
      membership.assignedPeople = [];
    }
    participant.allocatedMembership = undefined;
  });
};

/* Function updates the state based on the check-in */
export const updateStateOnCheckIn = (state: PosState) => {
  updateStateAfterMembershipCheckIn(state);
};
